/// <reference path="../_references.ts"/>

module App.TemplateStore {
	angular
		.module('templateStore', [])
		.config(['$stateProvider', ($stateProvider: ng.ui.IStateProvider) => {
			$stateProvider
				.state('zipSolutions.template-store', {
					url: 'template-store',
					data: {
						title: 'Template Store',
					},
					views: {
						'content@': {
							controller: 'TemplateStoreController',
							controllerAs: 'ctrl',
							templateUrl: 'html/template-store/template-store.html',
						},
					},
				})
				.state('zipSolutions.template-store.details' , {
					url: '/{id:int}',
					data: {
						title: 'Template View',
					},
					views: {
						'content@': {
							controller: 'TemplateViewController',
							controllerAs: 'ctrl',
							templateUrl: 'html/template-store/template-view.html',
						},
					},
				});
		}])
		.service('TemplateStoreService', TemplateStoreService.Factory())
		.controller('TemplateStoreController', TemplateStoreController)
		.controller('TemplateViewController', TemplateViewController);
}